import { Link, Outlet, useLocation } from '@remix-run/react'
import logoUrl from '#app/routes/_marketing+/logos/momentumlogo.png'

/**
 * Auth funnel layout. Same dark/ember palette as the marketing routes,
 * but stripped to a single logo at top — no nav, no footer. Auth pages
 * should reduce decisions, not invite browsing.
 *
 * The notation tutorial gets a wider column so its side-by-side
 * notation/parsed demos have room to breathe.
 */
export default function AuthLayout() {
	const isTutorial = useLocation().pathname.startsWith('/onboarding-tutorial')
	return (
		<div className="flex min-h-screen flex-col bg-ink text-ink-fg">
			<header className="px-6 pb-2 pt-8 md:px-10 md:pt-10">
				<Link
					to="/"
					className="inline-flex items-center gap-2"
					aria-label="Momentum home"
				>
					<img src={logoUrl} alt="" className="h-8 w-8" />
					<span className="font-display text-lg font-semibold tracking-tight">
						Momentum
					</span>
				</Link>
			</header>
			<main className="flex flex-1 items-start justify-center px-6 py-10 md:py-16">
				<div className={isTutorial ? 'w-full max-w-3xl' : 'w-full max-w-lg'}>
					<Outlet />
				</div>
			</main>
		</div>
	)
}
